import React from 'react';
import { useTranslation } from 'react-i18next';
import { DataGridCreateRow } from 'shared/components/ui/data-grid-create-row';
import { SortMode } from 'shared/hooks/use-data-grid-sorting';
import { ID } from 'shared/types/id';

import { DataHeaderRow } from './data-header-row';
import { DataRow } from './data-row';
import * as Styled from './goal-data-grid.style';
import { ColumnType, RowData } from './types';
import { useColumns } from './use-columns';

export type GoalDataGridViewProps = {
  rows: RowData[];
  columnTypes?: ColumnType[];
  sortMode: SortMode;
  columnToSort?: ColumnType;
  onSortChange: (columnType: ColumnType) => void;
  onGoal?: (id: ID) => void;
  isArchived?: boolean;
  onCreateGoal?: () => void;
  showPremiumLabel?: boolean;
  hasDndRows?: boolean;
  hideHeader?: boolean;
  isFrozen?: boolean;
};

export const GoalDataGridView: React.FC<GoalDataGridViewProps> = ({
  rows,
  columnTypes,
  sortMode,
  columnToSort,
  onSortChange,
  onGoal,
  isArchived,
  onCreateGoal,
  showPremiumLabel,
  hasDndRows,
  hideHeader,
  isFrozen,
}) => {
  const { t } = useTranslation();
  const columns = useColumns(columnTypes);

  return (
    <Styled.Container>
      {!hideHeader && (
        <DataHeaderRow
          columns={columns}
          sortMode={sortMode}
          onSortChange={onSortChange}
          columnToSort={columnToSort}
        />
      )}

      <Styled.Body>
        {rows.map((data) => (
          <Styled.BodyItem key={data.id}>
            <DataRow
              columns={columns}
              data={data}
              onGoal={onGoal}
              isSortable={!!hasDndRows}
              isFrozen={isFrozen}
              isArchived={isArchived}
            />
          </Styled.BodyItem>
        ))}

        {!!onCreateGoal && (
          <DataGridCreateRow
            label={t('general.labels.goal-table.footer.create.label')}
            onClick={onCreateGoal}
            showPremiumLabel={showPremiumLabel}
          />
        )}
      </Styled.Body>
    </Styled.Container>
  );
};
